import Icon from '../../components/Icon.vue'

Icon.register({"brands/etsy":{"width":384,"height":512,"paths":[{"d":"M384 348C382.3 358.8 370.3 458 368.5 480 250.6 475.7 148.6 475.3 0 480V454.5C45.5 445.6 60.6 446.5 61 419.3 62.8 346.9 64.5 175.1 61 97.3 60 68.8 48.9 70.5 0 61.3V35.8C73.9 38.1 255.9 44.3 363 32 359.5 70.3 355.2 158.5 355.2 158.5H332C320.9 115.7 313.2 68 277.3 68H140.3C130 68 129.5 71.5 129.5 77.8V241.5C187.5 242 218 239 218 239 247.8 238 245.6 230.5 258.8 173.7H284.5C280.1 275.1 280.6 235.6 282.8 334H257C247.8 293.9 247.9 273 217.5 272.5 217.5 272.5 196 270.5 129.5 270.5V409.5C129.5 435.5 143.7 447.7 173.7 447.7H263C326.6 447.7 329.6 422.8 361.8 348H384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/etsy.js
// module id = null
// module chunks = 